import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const leadFormService = {
  getAll, getOne, create, update, remove, rotateToken, submissions, schema,
}

export function getAll(params) { return apiHelper(API_URL).get('/crm/lead-forms', { params }) }
export function getOne(uuid) { return apiHelper(API_URL).get(`/crm/lead-forms/${uuid}`) }
export function create(data) { return apiHelper(API_URL).post('/crm/lead-forms', data) }
export function update(uuid, data) { return apiHelper(API_URL).put(`/crm/lead-forms/${uuid}`, data) }
export function remove(uuid) { return apiHelper(API_URL).delete(`/crm/lead-forms/${uuid}`) }
export function rotateToken(uuid) { return apiHelper(API_URL).patch(`/crm/lead-forms/${uuid}/token`) }
export function submissions(uuid, params) { return apiHelper(API_URL).get(`/crm/lead-forms/${uuid}/submissions`, { params }) }
export function schema() { return apiHelper(API_URL).get('/crm/lead-forms/schema') }
